namespace GeniuzPOS.Purchase {
    export interface ReportPurTaxLongData extends Serenity.ListRequest {
        Details?: ReportPurTaxLongRow[];
        Year?: string;
        Month?: string;
        BizName?: string;
        ShopName?: string;
        ShopAddress?: string;
        ShopTaxId?: string;
        BranchName?: string;
    }
}
